module.exports = __webpack_public_path__ + "img/test.12998ca2.jpg";